import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sun, Moon, Home, User, Mail } from "lucide-react";

// --- Navbar Component ---
const Navbar = ({ currentPage, setCurrentPage, toggleTheme, theme }) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 100, damping: 20 }}
      className={`fixed top-0 left-0 right-0 z-50 p-4 transition-colors duration-300 ${
        isSticky
          ? "bg-white/80 dark:bg-gray-900/80 shadow-lg backdrop-blur-sm text-black"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto flex justify-between items-center px-4">
        <motion.div
          className={`text-2xl font-bold dark:text-white-800`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          Portfolio
        </motion.div>
        <div className="flex items-center space-x-6">
          <ul className="flex space-x-6">
            <li>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setCurrentPage("home")}
                className={`flex items-center text-lg font-medium transition-colors duration-300 p-2 rounded-full ${
                  currentPage === "home"
                    ? "text-purple-600 dark:text-purple-400 bg-gray-700 dark:bg-gray-100"
                    : "text-gray dark:text-white-300 hover:text-purple-600 dark:hover:text-purple-400 hover:bg-gray-700 dark:hover:bg-gray-800"
                }`}
                aria-label="Home"
              >
                <Home size={24} />
              </motion.button>
            </li>
            <li>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setCurrentPage("about")}
                className={`flex items-center text-lg font-medium transition-colors duration-300 p-2 rounded-full ${
                  currentPage === "about"
                    ? "text-purple-600 dark:text-purple-400 bg-gray-700 dark:bg-gray-700"
                    : "text-gray dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400 hover:bg-gray-700 dark:hover:bg-gray-800"
                }`}
                aria-label="About"
              >
                <User size={24} />
              </motion.button>
            </li>
            <li>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setCurrentPage("contact")}
                className={`flex items-center text-lg font-medium transition-colors duration-300 p-2 rounded-full ${
                  currentPage === "contact"
                    ? "text-purple-600 dark:text-purple-400 bg-gray-700 dark:bg-gray-700"
                    : "text-gray dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400 hover:bg-gray-700 dark:hover:bg-gray-800"
                }`}
                aria-label="Contact"
              >
                <Mail size={24} />
              </motion.button>
            </li>
            {/* <li>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setCurrentPage("travelblog")}
                className={`flex items-center text-lg font-medium transition-colors duration-300 p-2 rounded-full ${
                  currentPage === "travelblog"
                    ? "text-purple-600 dark:text-purple-400 bg-gray-700 dark:bg-gray-700"
                    : "text-gray dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400 hover:bg-gray-700 dark:hover:bg-gray-800"
                }`}
                aria-label="Travel Blog"
              >
                <TicketsPlane size={24} />
              </motion.button>
            </li> */}
          </ul>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={toggleTheme}
            className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white transition-colors duration-300"
            aria-label="Toggle theme"
          >
            {theme === "dark" ? <Sun size={20} /> : <Moon size={20} />}
          </motion.button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;